import type { IntlShape } from 'react-intl';

import * as PM from '@/messages/payment';

import type { WithdrawalCode } from './types';

export type WithdrawalEligibilityMessageContext = {
  isGuestOrderLookup: boolean;
  withdrawalCode: WithdrawalCode | null;
};

export function localizedWithdrawalEligibilityErrorMessage(
  formatMessage: IntlShape['formatMessage'],
  { isGuestOrderLookup, withdrawalCode }: WithdrawalEligibilityMessageContext,
): string | null {
  if (!withdrawalCode) {
    return null;
  }

  switch (withdrawalCode) {
    case 'LOGIN_REQUIRED':
      return isGuestOrderLookup
        ? formatMessage(
            PM.paymentMessages.withdrawalLoginRequiredOrderStatusHint,
          )
        : formatMessage(PM.paymentMessages.withdrawalLoginRequired);
    case 'NO_MATCH':
    case 'ACCESS_DENIED':
    case 'VALIDATION_ERROR':
      return formatMessage(PM.paymentMessages.withdrawalOrderNotEligibleGlobal);
    default:
      return null;
  }
}
